'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _digest = require('./digest.js');

var from = function from(_ref) {
  var name = _ref.name,
      code = _ref.code,
      encode = _ref.encode;
  return new Hasher(name, code, encode);
};

var Hasher = /*#__PURE__*/function () {
  function Hasher(name, code, encode) {
    _classCallCheck(this, Hasher);

    this.name = name;
    this.code = code;
    this.encode = encode;
  }

  _createClass(Hasher, [{
    key: "digest",
    value: function () {
      var _digest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var digest$1;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(input instanceof Uint8Array)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return this.encode(input);

              case 3:
                digest$1 = _context.sent;
                return _context.abrupt("return", _digest.create(this.code, digest$1));

              case 7:
                throw Error('Unknown type, must be binary type');

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function digest(_x) {
        return _digest2.apply(this, arguments);
      }

      return digest;
    }()
  }]);

  return Hasher;
}();

exports.Hasher = Hasher;
exports.from = from;